import type { SessionNoteType } from '../model/session-note.types';

export const SAVING_INDICATOR_TIMEOUT = 3 * 1000; // 3 seconds
export const AUTOSAVE_THROTTLE = 2000; // 2 seconds

export const NOTE_COPY_INTRO_GUIDANCE_KEYS = {
    SOAP: 'note-copy-intro:SOAP',
    NESSO: 'note-copy-intro:NESSO',
} as const;
export const DEFAULT_NOTE_TYPE: SessionNoteType = 'SOAP';
